import React, {useState, useCallback, useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom'

import {Space, Table, Input, Select, Button, Image} from 'antd';
import Api from '../../api'
import TeacherModal from "../teacher/modal";
import {toTime} from '../../util/time'
import {VersionSON, SubjectSON, GradeSON, SectionJSON} from '../../util/dict'
import {split, filterJSON} from "../../util/transfer";

export default function CourseList() {
    let [searchParams, setSearchParams] = useSearchParams();
    let pageIndex = searchParams.get('pi') || 1
    let keyword = searchParams.get('keyword') || ''
    let statusCode = searchParams.get('statusCode')
    let typeCode = searchParams.get('typeCode')
    let lecturerId = searchParams.get('lecturerId')
    let lecturerName = searchParams.get('lecturerName')
    let sort = searchParams.get('sort')||2
    let time = searchParams.get('t')

    const navigate = useNavigate();
    const [list, setList] = useState([])
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [searchOptions, setSearchOptions] = useState({})

    useEffect(() => {
        getData();
    }, [pageIndex,keyword,statusCode,typeCode,lecturerId,sort, time])

    const columns = [
        {
            title: '课程信息',
            key: 'courseId',
            render: (_, record) => {
                return <div>
                    <div className="gray-dark fts-16 bold">{record.courseName}({record.courseId})</div>
                    <div className="mgt4 gray">{tolabels(record.sectionCode,record.gradeCode,
                        record.subjectCode, record.versionCode,record.label)}</div>
                    <div className="mgt4">{record.typeCode === 1 ? <span className="orange">系列课</span>
                        : <span className="green">单课</span>}</div>
                </div>
            }
        },
        {
            title: '缩略图',
            dataIndex: 'coverImg',
            width: 100,
            align: 'center',
            render: (coverImg) => <div>
                <Image
                    width={60}
                    height={40}
                    src={coverImg}
                />
            </div>
        },
        {
            title: '状态',
            dataIndex: 'statusCode',
            align: 'center',
            width: 100,
            render: (statusCode) => {
                if (statusCode === 1) {
                    return <span className="green">已上架</span>
                }
                if (statusCode === 0) {
                    return <span className="orange">待上架</span>
                }

                return <span className="gray">已下架</span>
            }
        },
        {
            title: '时间',
            key: 'createTime',
            align: 'center',
            width: 240,
            render: (_, record) => (<>
                <div>创建：{toTime(record.createTime)}</div>
                <div>更新：{toTime(record.updateTime)}</div>
            </>),
        }, {
            title: '课时',
            dataIndex: 'classNumber',
            align: 'center',
            width: 80,
            key: 'classNumber',
        }, {
            title: '观看人数',
            dataIndex: 'peopleNumber',
            align: 'center',
            width: 120,
            key: 'peopleNumber',
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            width: 230,
            render: (_, record) => (
                <Space size="middle" wrap>
                    <Button type="text" onClick={() => update(record)}>修改课程</Button>
                    {record.statusCode === 1 && <Button type="link" danger onClick={() => updateStatus(record.courseId, -1)}>下架课程</Button>}
                    {record.statusCode === -1 && <Button type="link"onClick={() => updateStatus(record.courseId, 1)}>重新上架</Button>}
                    {record.statusCode === 0 && <Button type="link" onClick={() => updateStatus(record.courseId, 1)}>上架课程</Button>}
                </Space>
            ),
        },
    ];

    const updateStatus = useCallback((id, status) => {
        Api.updateCourseStatus(id, status).then(resp => {
            if (resp.resultCode === 1) {
                let index = list.findIndex(item => item.courseId === id)
                if (index > -1) {
                    list[index].statusCode = status
                    setList([...list])
                }
            }
        })
    })
    const update = useCallback((record) => {
        if (record.typeCode === 1) {
            navigate('/course/series/' + record.courseId)
        } else {
            navigate('/course/single/' + record.courseId)
        }
    })

    const doSearch = useCallback((options) => {
        options.t = Date.now()
        setSearchOptions(filterJSON(options))
        setSearchParams(filterJSON(options))
    })

    const getData = useCallback(() => {
        if (loading) return;
        setLoading(true)
        Api.getCourseList({
            pageIndex,
            keyword,
            statusCode,
            typeCode,
            lecturerId,
            sort
        }).then(resp => {
            setLoading(false)
            setList(resp.list || [])
            setTotal(resp.totalCount)
        })
    })

    const onPagination = useCallback(function (index){
        setSearchParams({...searchOptions,'pi':index})
    })

    return (<>
            <div className="white-bg pdv40 pdh32" style={{minWidth: 800, maxWidth: 1400}}>
                <SearchBar onSearch={doSearch} defaultOption={{keyword,statusCode,sort,lecturerId,lecturerName,typeCode}}/>
                <Table
                    columns={columns}
                    dataSource={list}
                    rowKey="courseId"
                    pagination={{
                        total: total,
                        pageSize: 10,
                        current: parseInt(pageIndex),
                        onChange: onPagination,
                        showSizeChanger: false
                    }}
                />
            </div>
        </>
    );
};


function SearchBar({onSearch, defaultOption={}}) {
    const [keyword, setKeyword] = useState(defaultOption.keyword)
    const [statusCode, setStatusCode] = useState(defaultOption.statusCode?parseInt(defaultOption.statusCode):undefined)
    const [typeCode, setTypeCode] = useState(defaultOption.typeCode?parseInt(defaultOption.typeCode):undefined)
    const [lecturerId, setLecturerId] = useState(defaultOption.lecturerId)
    const [lecturerName, setLecturerName] = useState(defaultOption.lecturerName)
    const [sort, setSort] = useState(defaultOption.sort?parseInt(defaultOption.sort):2)

    const resetOptions = useCallback(() => {
        setKeyword()
        setStatusCode()
        setTypeCode()
        setLecturerId()
        setLecturerName()
        setSort()
    })

    const doSearch = useCallback(() => {
        onSearch && onSearch({
            keyword,
            statusCode,
            typeCode,
            lecturerId,
            lecturerName,
            sort
        })
    })
    const [showTeacherModal, setShowTeacherModal] = useState(false)
    const openTeacherModal = useCallback(() => {
        setShowTeacherModal(true)
    })
    const onTeacherModalClose = useCallback((data) => {
        setShowTeacherModal(false)
        if (data) {
            setLecturerId(data.lecturerId)
            setLecturerName(data.lecturerName)
        }
    })
    const onTeacherClear = useCallback(() => {
        setLecturerId()
        setLecturerName()
    })

    return (
        <>
            <div className="mgb32">
                <div className="flexbox wrap align-center">
                    <div className="mgb20">
                        <span>关键词：</span>
                        <Input placeholder="课程名称、标签"
                               value={keyword}
                               onChange={(e) => setKeyword(e.target.value)}
                               style={{width: 200, height: 32, marginRight: 32}}/>
                    </div>
                    <div className="mgb20">
                        <span>&#12288;状态：</span>
                        <Select
                            allowClear
                            value={statusCode}
                            onChange={(value) => setStatusCode(value)}
                            className="mgr32"
                            style={{width: 200}}
                            placeholder="请选择"
                            options={[
                                {value: 0, label: '待上架'},
                                {value: 1, label: '已上架'},
                                {value: -1, label: '已下架'},
                            ]}
                        />
                    </div>
                    <div className="mgb20">
                        <span>&#12288;类型：</span>
                        <Select
                            allowClear
                            value={typeCode}
                            onChange={(value) => setTypeCode(value)}
                            className="mgr32"
                            style={{width: 200}}
                            placeholder="请选择"
                            options={[
                                {value: 1, label: '系列课'},
                                {value: 2, label: '单课'}
                            ]}
                        />
                    </div>
                    <div className="mgb20">
                        <span>&#12288;讲师：</span>
                        <Select
                            allowClear
                            value={lecturerName}
                            onClear={onTeacherClear}
                            onDropdownVisibleChange={openTeacherModal}
                            open={false}
                            className="mgr32"
                            style={{width: 200}}
                            placeholder="请选择"
                        />
                    </div>
                    <div className="mgb20">
                        <span>&#12288;排序：</span>
                        <Select
                            allowClear
                            value={sort}
                            onChange={(value) => setSort(value)}
                            className="mgr32"
                            style={{width: 200}}
                            placeholder="请选择"
                            options={[
                                {value: 1, label: '创建时间'},
                                {value: 2, label: '更新时间'}
                            ]}
                        />
                    </div>
                </div>
                <div className="text-right">
                    <Space>
                        <Button type="primary" onClick={doSearch}>查询</Button>
                        <Button onClick={resetOptions}>重置</Button>
                    </Space>
                </div>
            </div>
            <TeacherModal isShow={showTeacherModal} onClose={onTeacherModalClose}/>
        </>
    )
}

function tolabels(sectionCode,gradeCode,subjectCode,versionCode, label){
    let labels = []
    if (sectionCode) {
        labels.push(SectionJSON[sectionCode])
    }
    if (gradeCode) {
        labels.push(GradeSON[gradeCode])
    }
    if (subjectCode) {
        labels.push(SubjectSON[subjectCode])
    }
    if (versionCode) {
        labels.push(VersionSON[versionCode])
    }
    labels = labels.concat(split(label,'|'))
    return labels.join(' | ')
}

